export { default as AccountMenu } from '../../components/AccountMenu.vue'
export { default as AppButton } from '../../components/AppButton.vue'
export { default as AppCard } from '../../components/AppCard.vue'
export { default as AppDialog } from '../../components/AppDialog.vue'
export { default as BorderedListItem } from '../../components/BorderedListItem.vue'
export { default as FooterLogo } from '../../components/FooterLogo.vue'
export { default as ResetPwdDialog } from '../../components/ResetPwdDialog.vue'
export { default as AnonymizationConfigAddAnonymizationConfigDialog } from '../../components/anonymization-config/AddAnonymizationConfigDialog.vue'
export { default as AnonymizationConfigCard } from '../../components/anonymization-config/AnonymizationConfigCard.vue'
export { default as AnonymizationConfigConstantEdit } from '../../components/anonymization-config/AnonymizationConfigConstantEdit.vue'
export { default as AnonymizationConfigItemEdit } from '../../components/anonymization-config/AnonymizationConfigItemEdit.vue'
export { default as AnonymizationConfigVariableEdit } from '../../components/anonymization-config/AnonymizationConfigVariableEdit.vue'
export { default as AnonymizationConfigImportAnonymizationConfigDialog } from '../../components/anonymization-config/ImportAnonymizationConfigDialog.vue'
export { default as CenterAddCenterDialog } from '../../components/center/AddCenterDialog.vue'
export { default as CenterAddUserInviteDialog } from '../../components/center/AddUserInviteDialog.vue'
export { default as CenterCard } from '../../components/center/CenterCard.vue'
export { default as CenterDialog } from '../../components/center/CenterDialog.vue'
export { default as CenterSelectCenterForTrialCard } from '../../components/center/SelectCenterForTrialCard.vue'
export { default as ClinicalTrialAddClinicalTrialDialog } from '../../components/clinical-trial/AddClinicalTrialDialog.vue'
export { default as ClinicalTrialAddClinicalTrialUserInvite } from '../../components/clinical-trial/AddClinicalTrialUserInvite.vue'
export { default as ClinicalTrialCard } from '../../components/clinical-trial/ClinicalTrialCard.vue'
export { default as ClinicalTrialStatisticsCard } from '../../components/clinical-trial/ClinicalTrialStatisticsCard.vue'
export { default as UploadAnonymizationDialog } from '../../components/upload/UploadAnonymizationDialog.vue'
export { default as UploadDropzone } from '../../components/upload/UploadDropzone.vue'
export { default as UploadMessageCard } from '../../components/upload/UploadMessageCard.vue'
export { default as UserInviteDeactivateUserDialog } from '../../components/user-invite/DeactivateUserDialog.vue'
export { default as UserInviteDeleteUserInviteDialog } from '../../components/user-invite/DeleteUserInviteDialog.vue'
export { default as UserInviteInvitedUsersPreviewCard } from '../../components/user-invite/InvitedUsersPreviewCard.vue'
export { default as UserInviteReactivateUserDialog } from '../../components/user-invite/ReactivateUserDialog.vue'

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
